export const ROUTES = {
  workflow: {
    path: '/',
    title: '',
    searchEnabled: false,
  },
  insights: {
    path: '/insights',
    title: 'Creative Insights Hub - Insights',
    searchEnabled: true,
  },
  advancedInsights: {
    path: '/advanced-insights',
    title: 'Creative Insights Hub - Advanced Insights',
    searchEnabled: true,
  },
  adsSummary: {
    path: '/ads-summary',
    title: 'Creative Insights Hub - Ads Summary',
    searchEnabled: true,
  },
  demo: {
    path: '/demo',
    title: 'Demo',
    searchEnabled: false,
  },
  admin: {
    path: '/admin',
    title: 'Admin',
    searchEnabled: false,
  },
} as const
